export default __webpack_public_path__ + "static/media/dashboard -03.f4a076dd.png";